import {getEditionMetadata} from 'shells/edition/get-edition-metadata';
import {getEditionStatusInfo} from 'shells/edition/get-edition-status-info';
import {GridList} from 'shells/grid-list/grid-list';
// @ts-expect-error - imported from .js/.jsx file
import {ArchiveIcon} from 'shells/icon/svg/archive-icon';
// @ts-expect-error - imported from .js/.jsx file
import {EyeIcon} from 'shells/icon/svg/eye-icon';
import {ReadOnlyText} from 'shells/sms-campaigns/read-only-text';
import {ThumbnailButtonCard} from 'shells/thumbnail/thumbnail-button-card/thumbnail-button-card';

import type {GetSmsBroadcastsVariables} from 'nutshell-graphql-types';

import {appHistory} from '../../../../history';

import {EmptyState} from './empty-state';
import {useDeleteSmsCampaign, useRestoreSmsCampaign} from './graphql/hooks';

type Props = {
    isLoading: boolean;
    error: string | null | undefined;
    smsBroadcasts: any[];
    onCreateBroadcast: () => void;
    isCreating: boolean;
    isFiltering: boolean;
    queryVariables: GetSmsBroadcastsVariables;
};

export function BroadcastsBoardView(props: Props) {
    const {deleteCampaign} = useDeleteSmsCampaign(props.queryVariables);
    const {restoreCampaign} = useRestoreSmsCampaign(props.queryVariables);

    return (
        <GridList
            isLoading={props.isLoading}
            itemWidth={300}
            loadingState={{itemHeight: 300, itemBackgroundColor: 'white'}}
            error={props.error}
            nothingFoundState={{title: 'No broadcasts were found'}}
            emptyStateComponent={
                <EmptyState
                    onPrimaryCtaClick={props.onCreateBroadcast}
                    isCreating={props.isCreating}
                />
            }
            isFiltering={props.isFiltering}
        >
            {props.smsBroadcasts.map((broadcast) => {
                const options = [
                    {
                        label: 'View',
                        handleSelect: () => {
                            appHistory.push(broadcast.edition.htmlUrlPath);
                        },
                        icon: <EyeIcon wrapWithDiv={false} size={18} />,
                    },
                ];

                if (!broadcast.edition.deletedTime) {
                    options.push({
                        label: 'Archive',
                        // @ts-expect-error
                        variant: 'destructive',
                        handleSelect: () => {
                            deleteCampaign(broadcast.id);
                        },
                        icon: <ArchiveIcon size={16} />,
                    });
                } else {
                    options.push({
                        label: 'Restore',
                        handleSelect: () => {
                            restoreCampaign(broadcast.id);
                        },
                        icon: <ArchiveIcon size={16} />,
                    });
                }

                return (
                    <ThumbnailButtonCard
                        key={broadcast.id}
                        title={broadcast.edition.name}
                        secondaryInfo={getEditionMetadata(broadcast.edition)}
                        tertiaryInfo={broadcast.owner && broadcast.owner.name}
                        to={broadcast.edition.htmlUrlPath}
                        thumbnail={
                            <div className='pad-16'>
                                <ReadOnlyText
                                    message={broadcast.edition.content}
                                    optOutText={broadcast.edition.optOutText}
                                    isFullWidth={true}
                                />
                            </div>
                        }
                        thumbnailHeight={175}
                        options={options}
                        statusBadge={getEditionStatusInfo(
                            broadcast.edition.deletedTime ? 'ARCHIVED' : broadcast.edition.status
                        )}
                    />
                );
            })}
        </GridList>
    );
}
